import generateCreateDefaultState from './generateCreateDefaultState';
import createJobDefaultReducer from './createJobDefaultReducer';

export default (
  state = generateCreateDefaultState('MANNING_BOOTH'),
  action
) => {
  return createJobDefaultReducer('MANNING_BOOTH', action, state);
};
